<template>
  <div class="mybody layout_body layout_parent" :style="{
      backgroundColor: body_b.radio_val !== 'hidden' ? body_b[body_b.radio_val].color : '',
      backgroundImage:body_b.radio_val !== 'hidden' && body_b[body_b.radio_val].img !== '' ? 'url('+body_b[body_b.radio_val].img+')' : 'none',
      backgroundSize: body_b.radio_val !== 'hidden' ? body_b[body_b.radio_val].background_size : 'auto',
      backgroundRepeat: body_b.radio_val !== 'hidden' ? body_b[body_b.radio_val].background_repeat : 'repeat',
      backgroundPosition: body_b.radio_val !== 'hidden' ? body_b[body_b.radio_val].background_position : '0% 0%',
    }" :class="$store.state.myRender.private && $store.state.myRender.private.fixed_background_isOpen == 'true' ? 'fixed_background_show' : ''">
    <template v-for="(val, i) in $store.state.myRender.body">
      <layout_row :row="val" :row_index="i" :key="val.widgets_id" v-show="$store.state.app.view_pattern == 'mb' ? val.data.mb_infor.isShow ? true : $store.state.mb_row_isShow.row_btn_isShow : true"></layout_row>
    </template>
  </div>
</template>

<script>
import layout_row from '@/widgets/layout_row/index.vue';
export default {
  name: 'mybody',
  data() {
    return {};
  },
  components: {
    layout_row
  },
  computed:{
    body_b() {
      return this.$store.state.myRender.common.body_background;
    }

  },
  methods: {

  },
  mounted() {

  }
};
</script>



// WEBPACK FOOTER //
// src/view/public/body.vue